import { STORAGE_KEYS } from "@chaman/constants"
import { AuthGuardSettings } from "@chaman/guards"

export const GUARD_SETTINGS: AuthGuardSettings = {
    allowedRoles: ['patient'],
    excludedRoutes: ['auth'],
    signinRoute: "/auth/signin",
    userLocalStorageKey: STORAGE_KEYS.CURRENT_USER
}